export class SkillActivityFilter {
    activityOriginatorType: any = null;
    operation: any = null;
    startDate: any = null;
    endDate: any = null;
    performedBy: any = null;
}